<!-- TODO: 컴포넌트 래핑 초안 - 스타일 및 기능 개선 필요 -->
<script setup lang="ts">
import { computed } from 'vue'
import { Label } from '@/components/shadcn'
import { cn } from '@/lib/utils'

type StyleType =
  | 'default'   // 기본 스타일
  | 'required' // 필수 필드 표시 (빨간 별표)
  | 'optional' // 선택 필드 표시 (회색 텍스트)
  | 'error'     // 에러 상태 (빨간 텍스트)
  | 'success'   // 성공 상태 (초록 텍스트)
  | 'warning'   // 경고 상태 (주황 텍스트)
  | 'sm'        // 작은 크기
  | 'lg'        // 큰 크기

const props = withDefaults(
  defineProps<{
    /** 라벨 텍스트 */
    text?: string
    /** 필수 필드 여부 */
    required?: boolean
    /** 스타일 프리셋 */
    styletype?: StyleType
    /** HTML for 속성 (연결할 input의 id) */
    for?: string
    /** 추가 클래스 (외부 커스터마이징용) */
    class?: string
  }>(),
  {
    text: '',
    required: false,
    styletype: 'default',
  },
)

/**
 * styletype -> class 매핑
 */
const STYLE_PRESETS: Record<StyleType, { class: string }> = {
  default: { class: '' },
  required: { 
    class: 'text-red-600',
  },
  optional: { 
    class: 'text-gray-500',
  },
  error: { 
    class: 'text-red-600',
  },
  success: { 
    class: 'text-green-600',
  },
  warning: { 
    class: 'text-amber-600',
  },
  sm: { 
    class: 'text-xs',
  },
  lg: { 
    class: 'text-base',
  },
}

/** 최종 바인딩: styletype에 따른 클래스 적용 */
const mapped = computed(() => {
  const styleKey = props.styletype || 'default'
  const preset = STYLE_PRESETS[styleKey] ?? STYLE_PRESETS.default
  
  return {
    for: props.for,
    class: preset?.class || '',
  }
})

const displayText = computed(() => {
  if (props.text) {
    return props.text
  }
  return ''
})
</script>

<template>
  <Label
    :for="mapped.for"
    :class="cn(
      'text-xs font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      mapped.class,
      props.class
    )"
  >
    <span v-if="required && styletype === 'required'" class="text-red-500 mr-1">*</span>
    <span v-else-if="required" class="text-red-500 mr-1">*</span>
    {{ displayText }}
    <slot />
  </Label>
</template>
